module.exports = {"id":"207791","name":"Yussuf Poulsen","rating":"77","photo":"./data/images/photos/1/207791.png","club":{"name":"RB Leipzig","logo":"./data/images/clubs/RBLeipzig.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YussufPoulsen0.json
// module id = 4449
// module chunks = 0